module.exports = __webpack_public_path__ + "static/img/settled in.0286856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/settled in.png
// module id = tX4V
// module chunks = 1